import { useParams } from "react-router-dom";
import VenueClubDetailsPage from "./Club-aboutus/VenueClubDetailsPage";
import PopularPackageView from "./favorate-hangout-page/Popular--Package--view--all";

const DynamicPageRouter = () => {
  const { slug, city } = useParams(); 

  if (slug.startsWith("party-packages-")) {
    return <PopularPackageView packagetype={slug} city={city} />;
  }

  // fallback to club page
  return <VenueClubDetailsPage clubInfo={slug} />;
};

export default DynamicPageRouter;
